import { Colors, Icon, MultilineInput } from '@amelio/ui-library';
import { useState } from 'react';

import { useAmelioTranslations } from '@/hooks/utils/useAmelioTranslations';

interface ReplyInputProps {
    onSubmit: (content: string) => void | Promise<void>;
    isSubmitting?: boolean;
    dataTestId?: string;
}

export const ReplyInput = ({
    onSubmit,
    isSubmitting = false,
    dataTestId = 'reply-input',
}: ReplyInputProps) => {
    const { t } = useAmelioTranslations();
    const [replyText, setReplyText] = useState('');

    const handleReplySubmit = async () => {
        const trimmedText = replyText.trim();
        if (!trimmedText || isSubmitting) {
            return;
        }

        await onSubmit(trimmedText);
        setReplyText('');
    };

    return (
        <div
            className={'my-8 flex items-center gap-5'}
            data-testid={dataTestId}
        >
            <div className={'flex-1 rounded-xl'}>
                <MultilineInput
                    value={replyText}
                    onChange={(value) => setReplyText(value)}
                    rows={1}
                    placeholder={t('questionResult.replyPlaceholder')}
                    className={'border-base-400 w-full !rounded-3xl'}
                    onEnterPress={handleReplySubmit}
                    ariaLabel={t('questionResult.replyPlaceholder')}
                    dataTestId={'comment-reply-input'}
                    autoGrow
                />
            </div>

            <div className={`${isSubmitting ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                <Icon
                    name={'essential-send'}
                    color={Colors.BASE_600}
                    size={'xl'}
                    onClick={handleReplySubmit}
                    disabled={!replyText.trim() || isSubmitting}
                    className={'shrink-0'}
                    dataTestId={`${dataTestId}-submit`}
                />
            </div>
        </div>
    );
};
